import React from "react";

import { Grid, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import Container from "../../../../components/Container";
import theme from "../../../../constants/theme";
import birthPlanBackground from "../../../../assets/images/background-birth-plan.jpg";
import stepOne from "../../../../assets/images/step-one.png";
import stepTwo from "../../../../assets/images/step-two.png";
import stepThree from "../../../../assets/images/step-three.png";
import Button from "../../../../components/Button";
import {routes} from "../../../../api/paths";
import {useHistory} from "react-router-dom";

const useStyles = makeStyles(() =>
  createStyles({
    center: {
      textAlign: "center",
      padding: theme.spacing(10, 4),
    },
    heading: {
      padding: theme.spacing(10, 0, 5, 0),
      textAlign: "center",
    },
    background: {
      backgroundImage: `url(${birthPlanBackground})`,
      margin: theme.spacing(10, 0),
      paddingBottom: theme.spacing(10),
    },
    margin: {
      margin: theme.spacing(6, 0, 10, 0),
    },
    instruction: {
      margin: theme.spacing(5, 0),
    },
    instructionFontSize: {
      fontSize: 22,
      [theme.breakpoints.only("xs")]: {
        fontSize: 16,
      },
    },
  })
);

export default function Instructions() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.background}>
      <Container>
        <Typography variant="h3" className={classes.heading}>
          Kako ispuniti plan poroda?
        </Typography>
        <Grid
          container
          spacing={3}
          className={classes.instruction}
          alignItems="center"
        >
          <Grid item md={3} xs={4}>
            <img src={stepOne} alt="plan poroda" style={{ width: "5rem" }} />
          </Grid>
          <Grid item md={8} xs={8}>
            <Typography className={classes.instructionFontSize}>
              Otvorite stranicu za kreiranje plana poroda.
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          className={classes.instruction}
          alignItems="center"
        >
          <Grid item md={3} xs={4}>
            <img src={stepTwo} alt="plan poroda" style={{ width: "5rem" }} />
          </Grid>
          <Grid item md={8} xs={8}>
            <Typography className={classes.instructionFontSize}>
              Ispunite samo ona polja koja želite — ništa nije obavezno! Plan će
              ispisati samo ona polja koje ste ispunili.
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          className={classes.instruction}
          alignItems="center"
        >
          <Grid item md={3} xs={4}>
            <img src={stepThree} alt="plan poroda" style={{ width: "5rem" }} />
          </Grid>
          <Grid item md={8} xs={8}>
            <Typography className={classes.instructionFontSize}>
              Spremite svoje promjene i preuzmite PDF dokument koji možete
              ispisati i ponijeti sa sobom na bolničke preglede i sam porod.
            </Typography>
          </Grid>
        </Grid>
        <Grid
            container
            spacing={3}
            className={classes.instruction}
            alignItems="center"
        >
          <Grid item md={8} xs={8}>
            <Button
                onClick={() => {
                  history.push(routes.BIRTH_PLAN_FORM);
                }}
            >
              Napravite svoj Online plan poroda
            </Button>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
